import { Record, Iterable, fromJS, Map as ImmutableMap, List } from 'immutable';
import TwoFactorAuthConfig from './TwoFactorAuthConfig';
const TwoFactorAuthStatus = Record({
  primary: null,
  secondary: null,
  enabled: false,
  backupCodesResponse: ImmutableMap({
    backupCodes: List(),
    createdAt: null
  })
}, 'TwoFactorAuthStatus');
function fromJSReviver(key, value) {
  const isIndexed = Iterable.isIndexed(value);
  if (key === 'primary' || key === 'secondary') {
    return new TwoFactorAuthConfig(value);
  }
  return isIndexed ? value.toList() : value.toMap();
}
export function fromJSON(obj) {
  return new TwoFactorAuthStatus(fromJS(obj, fromJSReviver));
}
export default TwoFactorAuthStatus;